import { render, staticRenderFns } from "./bd.vue?vue&type=template&id=2e9f5839&scoped=true"
import script from "./bd.vue?vue&type=script&lang=js"
export * from "./bd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e9f5839",
  null
  
)

export default component.exports